import type { LocalizedDict } from '../index'

export type AudienceModalStrings = {
  orgIdPlaceholder: string
}

export const audienceModalI18n: LocalizedDict<AudienceModalStrings> = {
  en: { orgIdPlaceholder: 'org id…' },
  tr: { orgIdPlaceholder: 'kuruluş kimliği…' },
}
